module.exports = "<svg className='bars-icon' viewBox='0 0 24 24'>\n  <path d='M1,1 L22,22 M1,22 L22,1' stroke='#000' stroke-width='2' />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/images/icons/close-icon.svg
// module id = 400
// module chunks = 37